import { useState } from "react";
import {
    Box,
    Collapse,
    Drawer,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    ListSubheader,
    Typography,
} from "@mui/material";
import JournalDrawerMenuProps from "@/src/_types/journal-drawer-menu-props";
import DrawerLink from "@/src/components/common/_partials/header/drawer-link/drawer-link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-duotone-svg-icons";

const DrawerMenu = ({
    open,
    toggleDrawer,
    menuItems,
    journalTitle,
    journalSubtitle,
    authorGuide,
    submission,
}: JournalDrawerMenuProps) => {
    const [collapseOpen, setCollapseOpen] = useState<boolean[]>([]);

    const handleToggle = (index: number) => {
        const newCollapseOpen = [...collapseOpen];
        newCollapseOpen[index] = !newCollapseOpen[index];
        setCollapseOpen(newCollapseOpen);
    };

    const allMenuItems = [...menuItems, authorGuide, submission];

    return (
        <Drawer
            anchor="left"
            open={open}
            onClose={() => toggleDrawer(false)}
            PaperProps={{
                sx: {
                    width: 250,
                    backgroundColor: "#047778",
                },
            }}
        >
            <List
                subheader={
                    <ListSubheader
                        sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            flexDirection: "column",
                            gap: 0.5,
                            paddingY: 0.5,
                            backgroundColor: "#036565",
                        }}
                    >
                        <Typography
                            component="h1"
                            color="custom.teal"
                            sx={{
                                fontWeight: 700,
                                fontSize: "1.25rem"
                            }}
                        >
                            {
                                journalTitle
                            }
                        </Typography>
                        <Typography
                            component="h2"
                            color="custom.teal"
                            sx={{ fontSize: ".75rem" }}
                        >
                            {
                                journalSubtitle
                            }
                        </Typography>
                    </ListSubheader>
                }
            >
                {
                    allMenuItems.map((item, index) => (
                        <Box key={index}>
                            {!item.children ? (
                                <DrawerLink
                                    color="custom.teal"
                                    link={item.link || "#"}
                                    key={index}
                                >
                                    <ListItem>
                                        <ListItemIcon
                                            sx={{
                                                color: "custom.teal",
                                            }}
                                        >
                                            <i className={item.icon} />
                                        </ListItemIcon>
                                        <ListItemText 
                                            primary={item.label} 
                                            sx={{ color: 'custom.teal' }} 
                                        />
                                    </ListItem>
                                </DrawerLink>
                            ) : (
                                <>
                                    <ListItem
                                        sx={{
                                            color: "custom.teal",
                                        }}
                                        onClick={() => handleToggle(index)}
                                    >
                                        <ListItemIcon
                                            sx={{
                                                color: "custom.teal",
                                            }}
                                        >
                                            <i className={item.icon} />
                                        </ListItemIcon>
                                        <ListItemText primary={item.label} />
                                        {collapseOpen[index] ? (
                                            <FontAwesomeIcon icon={faChevronUp} />
                                        ) : (
                                            <FontAwesomeIcon icon={faChevronDown} />
                                        )}
                                    </ListItem>
                                    <Collapse 
                                        in={collapseOpen[index]} 
                                        sx={{ ml: 1 }}
                                    >
                                        <List 
                                            component="div" 
                                            disablePadding
                                        >
                                            {
                                                item.children.map((child, childIndex) => (
                                                    <DrawerLink
                                                        color={"custom.teal"}
                                                        link={child.link || "#"}
                                                        key={childIndex}
                                                    >
                                                        <ListItem>
                                                            <ListItemIcon 
                                                                sx={{ color: 'custom.teal' }}
                                                            >
                                                                <i className={child.icon} />
                                                            </ListItemIcon>
                                                            <ListItemText 
                                                                primary={child.label} 
                                                                sx={{ color: 'custom.teal' }} 
                                                            />
                                                        </ListItem>
                                                    </DrawerLink>
                                                ))
                                            }
                                        </List>
                                    </Collapse>
                                </>
                            )}
                        </Box>
                    ))
                }
            </List>
        </Drawer>
    );
};

export default DrawerMenu;
